import Icon from '../../../../IconUpdated';
import PropTypes from 'prop-types';
import Typography from '../../../../Typography';

const ProductSelectorHeading = ({ builderConfig, packConfig }) => {
	return (
		<div className="hidden md:flex flex-col justify-center text-center">
			<Typography variant="subhead-md">Customize your pack</Typography>
			<div className="flex justify-center">
				<Icon name="sparkle" height="16px" width="16px" />
				{builderConfig.builderType === 'socks' && (
					<Typography className="-ml-[1px] mt-1" variant="small">
						Socks are 3 for 33, and $11/pair for any additional pairs.{' '}
						{packConfig.selectedProducts?.length < 3
							? `Add ${3 - packConfig.selectedProducts.length} to unlock savings`
							: 'Savings Unlocked'}
					</Typography>
				)}
				{builderConfig.builderType !== 'socks' && (
					<Typography className="-ml-[1px] mt-1" variant="small">
						The more you add, the more you save (psst. up to 33%)
					</Typography>
				)}
			</div>
		</div>
	);
};

ProductSelectorHeading.propTypes = {
	builderConfig: PropTypes.object,
	packConfig: PropTypes.object,
};

export default ProductSelectorHeading;
